import { CashTableItem } from '../screens/monitoring/store/types';

export type ResultCashCheck = {
  head: string[];
  body: CashTableItem[];
};

export const mapCheckResponse = (data: any): ResultCashCheck => {
  const result: CashTableItem[] = [];
  const head: string[] = ['Название', 'Сумма', 'Цена', 'Кол'];

  if (!data?.table?.body) return { head, body: result };

  data.table.body.forEach((row: any) => {
    if (row.rowType === 2) {
      const name = row.rowName.replace(/&nbsp;/g, '').trim() ?? '';
      const sum = row.sum?.sortValue;
      const priceSum = row.guests?.sortValue;
      const qnt = row.checks?.sortValue;

      result.push({ name, sum, priceSum, qnt });
    }
  });

  return { head, body: result };
};

// export const mapCheckResponse = (data: any): ResultCashCheck => {
//     const head: Head = [];
//     const body: Body = [];

//     if (data?.table?.head) {
//         // Извлекаем заголовки из `data.table.head`
//         data.table.head.forEach((column: any) => {
//             const title = column.title?.replace(/&nbsp;/g, '').trim() || '';

//             // Проверяем, есть ли в заголовке даты формата dd.mm - dd.mm
//             const dateRangeMatch = title.match(/\d{2}\.\d{2}\s*-\s*\d{2}\.\d{2}/);
//             console.log('dateRangeMatch', dateRangeMatch);
//             if (dateRangeMatch) {
//                 head.push(dateRangeMatch[0]); // Если даты найдены, добавляем их в `head`
//             } else {
//                 head.push(title);
//             }
//         });
//     }

//     if (data?.table?.body) {
//         // Преобразуем строки таблицы в массив строк (Body)
//         data.table.body.forEach((row: any) => {
//             const rowData: string[] = [];
//             data.table.head.forEach((column: any) => {
//                 const key = column.data;
//                 if (typeof key === 'string') {
//                     // Простое поле
//                     rowData.push(row[key]?.replace(/&nbsp;/g, '').trim() ?? '');
//                 } else if (key && key._) {
//                     // Комплексное поле
//                     const value = getNestedValue(row, key._);
//                     rowData.push(value?.toString()?.replace(/&nbsp;/g, '').trim() ?? '');
//                 } else {
//                     rowData.push('');
//                 }
//             });
//             body.push(rowData);
//         });
//     }

//     return {head, body};
// };
